import React from "react";
import { Routes, Route } from "react-router-dom";
import { Login } from "../auth/Login";

export const AuthRoutes = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="*" element={<Login />} />
    </Routes>
  );
};
